var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ListEditView" },
    [
      _vm.hasAdd
        ? _vm._t(
            "add",
            function () {
              return [
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.add()
                      },
                    },
                  },
                  [_vm._v("Add store")]
                ),
              ]
            },
            {
              add: () => _vm.add(),
              addAppend: () => _vm.add(),
              addPrepend: () => _vm.addPrepend(),
            }
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "sortable-list",
        {
          attrs: {
            lockAxis: _vm.lockAxis,
            axis: _vm.axis,
            value: _vm.value,
            useDragHandle: true,
            distance: _vm.distance,
            helperClass: _vm.helperClass,
            shouldCancelStart: _vm.shouldCancelStart,
          },
          on: { input: _vm.update },
        },
        [
          _vm._l(_vm.valueList, function (item, index) {
            return !item.removed
              ? _c(
                  "sortable-item",
                  {
                    key: item.id || item.cid || "i" + index,
                    attrs: { index: index, item: item },
                  },
                  [
                    _vm._t(
                      "default",
                      function () {
                        return [
                          _vm._v("\n\t\t\t\t" + _vm._s(item) + "\n\t\t\t"),
                        ]
                      },
                      {
                        item: item,
                        index: index,
                        remove: () => _vm.remove(index),
                      }
                    ),
                  ],
                  2
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.hasAddInline
            ? _vm._t(
                "add-inline",
                function () {
                  return [
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.add()
                          },
                        },
                      },
                      [_vm._v("Add Inline")]
                    ),
                  ]
                },
                { add: () => _vm.add() }
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.validationList && _vm.validationList.$error
            ? _c("div", { staticClass: "ListEditViewErrors u-ErrorView" }, [
                _vm.validationList.required === false
                  ? _c(
                      "div",
                      { staticClass: "error" },
                      [
                        _vm._t(
                          "error-required",
                          function () {
                            return [_vm._v("List must not be empty.")]
                          },
                          { error: _vm.validationList }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.validationList.minLength === false
                  ? _c(
                      "div",
                      { staticClass: "error" },
                      [
                        _vm._t(
                          "error-minLength",
                          function () {
                            return [
                              _vm._v(
                                "\n\t\t\t\t\tList must have at least\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.validationList.$params.minLength.min
                                  ) +
                                  " elements.\n\t\t\t\t"
                              ),
                            ]
                          },
                          { error: _vm.validationList }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }